export const SAVE_CURRENT_DATE_RANGE = 'SAVE_CURRENT_DATE_RANGE';
export const SAVE_SELECTED_COMPANY = 'SAVE_SELECTED_COMPANY';
export const SAVE_DATE_RANGE_12_MONTHS = 'SAVE_DATE_RANGE_12_MONTHS';
export const SAVE_DATE_RANGE_90_DAYS = 'SAVE_DATE_RANGE_90_DAYS';
export const SAVE_DATE_RANGE_30_DAYS = 'SAVE_DATE_RANGE_30_DAYS';

export const GET_CORPORATE_LIST = 'GET_CORPORATE_LIST';
export const GET_CORPORATE_LIST_LOADING = 'GET_CORPORATE_LIST_LOADING';
export const GET_CORPORATE_LIST_ERROR = 'GET_CORPORATE_LIST_ERROR';

export const GET_FREEMIUM_CORPORATE_LIST = 'GET_FREEMIUM_CORPORATE_LIST';
export const GET_FREEMIUM_CORPORATE_LIST_LOADING = 'GET_FREEMIUM_CORPORATE_LIST_LOADING';
export const GET_FREEMIUM_CORPORATE_LIST_ERROR = 'GET_FREEMIUM_CORPORATE_LIST_ERROR';

export const SAVE_CORP_ID_NAME_MAP = 'SAVE_CORP_ID_NAME_MAP';
export const SAVE_FREEMIUM_CORP_ID_NAME_MAP = 'SAVE_FREEMIUM_CORP_ID_NAME_MAP';

export const GET_PAID_REGISTERED_USERS = 'GET_PAID_REGISTERED_USERS';
export const GET_PAID_REGISTERED_USERS_LOADING = 'GET_PAID_REGISTERED_USERS_LOADING';
export const GET_PAID_REGISTERED_USERS_ERROR = 'GET_PAID_REGISTERED_USERS_ERROR';

export const GET_PAID_REGISTERED_USERS_LAST_90_DAYS = 'GET_PAID_REGISTERED_USERS_LAST_90_DAYS';
export const GET_PAID_REGISTERED_USERS_LAST_30_DAYS = 'GET_PAID_REGISTERED_USERS_LAST_30_DAYS';

export const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';
export const GET_ACTIVE_USERS_LOADING = 'GET_ACTIVE_USERS_LOADING';
export const GET_ACTIVE_USERS_ERROR = 'GET_ACTIVE_USERS_ERROR';

export const GET_ACTIVE_USERS_LAST_90_DAYS = 'GET_ACTIVE_USERS_LAST_90_DAYS';
export const GET_ACTIVE_USERS_LAST_30_DAYS = 'GET_ACTIVE_USERS_LAST_30_DAYS';

export const GET_KPI_DATA = 'GET_KPI_DATA';
export const GET_KPI_DATA_LOADING = 'GET_KPI_DATA_LOADING';
export const GET_KPI_DATA_ERROR = 'GET_KPI_DATA_ERROR';

export const GET_TOTAL_USERS_PLAYED_CONTENT = 'GET_TOTAL_USERS_PLAYED_CONTENT';
export const GET_TOTAL_USERS_PLAYED_CONTENT_LOADING = 'GET_TOTAL_USERS_PLAYED_CONTENT_LOADING';
export const GET_TOTAL_USERS_PLAYED_CONTENT_ERROR = 'GET_TOTAL_USERS_PLAYED_CONTENT_ERROR';

export const GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS =
  'GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS';
export const GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS =
  'GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS';

export const GET_TOTAL_MINS_PLAYED = 'GET_TOTAL_MINS_PLAYED';
export const GET_TOTAL_MINS_PLAYED_LOADING = 'GET_TOTAL_MINS_PLAYED_LOADING';
export const GET_TOTAL_MINS_PLAYED_ERROR = 'GET_TOTAL_MINS_PLAYED_ERROR';

export const GET_TOTAL_MINS_PLAYED_LAST_90_DAYS = 'GET_TOTAL_MINS_PLAYED_LAST_90_DAYS';
export const GET_TOTAL_MINS_PLAYED_LAST_30_DAYS = 'GET_TOTAL_MINS_PLAYED_LAST_30_DAYS';

export const GET_USERS_RATED_THE_CONTENT = 'GET_USERS_RATED_THE_CONTENT';
export const GET_USERS_RATED_THE_CONTENT_LOADING = 'GET_USERS_RATED_THE_CONTENT_LOADING';
export const GET_USERS_RATED_THE_CONTENT_ERROR = 'GET_USERS_RATED_THE_CONTENT_ERROR';

export const GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS = 'GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS';
export const GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS = 'GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS';

export const GET_USERS_FAVORITE_THE_CONTENT = 'GET_USERS_FAVORITE_THE_CONTENT';
export const GET_USERS_FAVORITE_THE_CONTENT_LOADING = 'GET_USERS_FAVORITE_THE_CONTENT_LOADING';
export const GET_USERS_FAVORITE_THE_CONTENT_ERROR = 'GET_USERS_FAVORITE_THE_CONTENT_ERROR';

export const GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS =
  'GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS';
export const GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS =
  'GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS';

export const GET_TOTAL_STEPS_CAPTURED = 'GET_TOTAL_STEPS_CAPTURED';
export const GET_TOTAL_STEPS_CAPTURED_LOADING = 'GET_TOTAL_STEPS_CAPTURED_LOADING';
export const GET_TOTAL_STEPS_CAPTURED_ERROR = 'GET_TOTAL_STEPS_CAPTURED_ERROR';

export const GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS = 'GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS';
export const GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS = 'GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS';

export const GET_TOTAL_USER_SYNCING_STEPS = 'GET_TOTAL_USER_SYNCING_STEPS';
export const GET_TOTAL_USER_SYNCING_STEPS_LOADING = 'GET_TOTAL_USER_SYNCING_STEPS_LOADING';
export const GET_TOTAL_USER_SYNCING_STEPS_ERROR = 'GET_TOTAL_USER_SYNCING_STEPS_ERROR';

export const GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS =
  'GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS';
export const GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS =
  'GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS';

export const GET_NUMBER_OF_PC_COMPLETED = 'GET_NUMBER_OF_PC_COMPLETED';
export const GET_NUMBER_OF_PC_COMPLETED_LOADING = 'GET_NUMBER_OF_PC_COMPLETED_LOADING';
export const GET_NUMBER_OF_PC_COMPLETED_ERROR = 'GET_NUMBER_OF_PC_COMPLETED_ERROR';

export const GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS = 'GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS';
export const GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS = 'GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS';

export const GET_NUMBER_OF_PC_BOOKINGS = 'GET_NUMBER_OF_PC_BOOKINGS';
export const GET_NUMBER_OF_PC_BOOKINGS_LOADING = 'GET_NUMBER_OF_PC_BOOKINGS_LOADING';
export const GET_NUMBER_OF_PC_BOOKINGS_ERROR = 'GET_NUMBER_OF_PC_BOOKINGS_ERROR';

export const GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS = 'GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS';
export const GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS = 'GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS';

export const GET_NUMBER_OF_USERS_TAKE_WATER = 'GET_NUMBER_OF_USERS_TAKE_WATER';
export const GET_NUMBER_OF_USERS_TAKE_WATER_LOADING = 'GET_NUMBER_OF_USERS_TAKE_WATER_LOADING';
export const GET_NUMBER_OF_USERS_TAKE_WATER_ERROR = 'GET_NUMBER_OF_USERS_TAKE_WATER_ERROR';

export const GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS =
  'GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS';
export const GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS =
  'GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS';

export const GET_TOTAL_WATER_INTAKE = 'GET_TOTAL_WATER_INTAKE';
export const GET_TOTAL_WATER_INTAKE_LOADING = 'GET_TOTAL_WATER_INTAKE_LOADING';
export const GET_TOTAL_WATER_INTAKE_ERROR = 'GET_TOTAL_WATER_INTAKE_ERROR';

export const GET_TOTAL_EARNED_REWARD_POINTS = 'GET_TOTAL_EARNED_REWARD_POINTS';
export const GET_TOTAL_EARNED_REWARD_POINTS_LOADING = 'GET_TOTAL_EARNED_REWARD_POINTS_LOADING';
export const GET_TOTAL_EARNED_REWARD_POINTS_ERROR = 'GET_TOTAL_EARNED_REWARD_POINTS_ERROR';

export const GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS =
  'GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS';
export const GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS =
  'GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS';

export const GET_TOTAL_REDEEMED_REWARD_POINTS = 'GET_TOTAL_REDEEMED_REWARD_POINTS';
export const GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING = 'GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING';
export const GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR = 'GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR';

export const GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS =
  'GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS';
export const GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS =
  'GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS';

export const GET_TOTAL_USERS_EARNED_REWARDS = 'GET_TOTAL_USERS_EARNED_REWARDS';
export const GET_TOTAL_USERS_EARNED_REWARDS_LOADING = 'GET_TOTAL_USERS_EARNED_REWARDS_LOADING';
export const GET_TOTAL_USERS_EARNED_REWARDS_ERROR = 'GET_TOTAL_USERS_EARNED_REWARDS_ERROR';

export const GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS =
  'GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS';
export const GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS =
  'GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS';

export const GET_TOTAL_USERS_REDEEMED_REWARDS = 'GET_TOTAL_USERS_REDEEMED_REWARDS';
export const GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING = 'GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING';
export const GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR = 'GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR';

export const GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS =
  'GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS';
export const GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS =
  'GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS';

export const GET_TOTAL_PUSH_SENT = 'GET_TOTAL_PUSH_SENT';
export const GET_TOTAL_PUSH_SENT_LOADING = 'GET_TOTAL_PUSH_SENT_LOADING';
export const GET_TOTAL_PUSH_SENT_ERROR = 'GET_TOTAL_PUSH_SENT_ERROR';

export const GET_TOTAL_PUSH_SENT_LAST_90_DAYS = 'GET_TOTAL_PUSH_SENT_LAST_90_DAYS';
export const GET_TOTAL_PUSH_SENT_LAST_30_DAYS = 'GET_TOTAL_PUSH_SENT_LAST_30_DAYS';

export const GET_TOTAL_CHALLENGES_LAUNCHED = 'GET_TOTAL_CHALLENGES_LAUNCHED';
export const GET_TOTAL_CHALLENGES_LAUNCHED_LOADING = 'GET_TOTAL_CHALLENGES_LAUNCHED_LOADING';
export const GET_TOTAL_CHALLENGES_LAUNCHED_ERROR = 'GET_TOTAL_CHALLENGES_LAUNCHED_ERROR';

export const GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS =
  'GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS';
export const GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS =
  'GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS';

export const GET_TOTAL_USERS_JOINED_IN_CHALLENGE = 'GET_TOTAL_USERS_JOINED_IN_CHALLENGE';
export const GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING =
  'GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING';
export const GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR =
  'GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR';

export const GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS =
  'GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS';
export const GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS =
  'GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS';

export const GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE =
  'GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE';
export const GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING =
  'GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING';
export const GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR =
  'GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR';

export const GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS =
  'GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS';
export const GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS =
  'GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS';

export const GET_PROGRAM_JOINED = 'GET_PROGRAM_JOINED';
export const GET_PROGRAM_JOINED_LOADING = 'GET_PROGRAM_JOINED_LOADING';
export const GET_PROGRAM_JOINED_ERROR = 'GET_PROGRAM_JOINED_ERROR';

export const GET_PROGRAM_JOINED_LAST_90_DAYS = 'GET_PROGRAM_JOINED_LAST_90_DAYS';
export const GET_PROGRAM_JOINED_LAST_30_DAYS = 'GET_PROGRAM_JOINED_LAST_30_DAYS';

export const GET_PROGRAM_COMPLETED = 'GET_PROGRAM_COMPLETED';
export const GET_PROGRAM_COMPLETED_LOADING = 'GET_PROGRAM_COMPLETED_LOADING';
export const GET_PROGRAM_COMPLETED_ERROR = 'GET_PROGRAM_COMPLETED_ERROR';

export const GET_PROGRAM_COMPLETED_LAST_90_DAYS = 'GET_PROGRAM_COMPLETED_LAST_90_DAYS';
export const GET_PROGRAM_COMPLETED_LAST_30_DAYS = 'GET_PROGRAM_COMPLETED_LAST_30_DAYS';

export const GET_BOOK_READ = 'GET_BOOK_READ';
export const GET_BOOK_READ_LOADING = 'GET_BOOK_READ_LOADING';
export const GET_BOOK_READ_ERROR = 'GET_BOOK_READ_ERROR';

export const GET_BOOK_READ_LAST_90_DAYS = 'GET_BOOK_READ_LAST_90_DAYS';
export const GET_BOOK_READ_LAST_30_DAYS = 'GET_BOOK_READ_LAST_30_DAYS';

export const GET_INDIVIDUAL_DETAILS = 'GET_INDIVIDUAL_DETAILS';
export const GET_INDIVIDUAL_DETAILS_LOADING = 'GET_INDIVIDUAL_DETAILS_LOADING';
export const GET_INDIVIDUAL_DETAILS_ERROR = 'GET_INDIVIDUAL_DETAILS_ERROR';
export const GET_INDIVIDUAL_DETAILS_LAST_90_DAYS = 'GET_INDIVIDUAL_DETAILS_LAST_90_DAYS';
export const GET_INDIVIDUAL_DETAILS_LAST_30_DAYS = 'GET_INDIVIDUAL_DETAILS_LAST_30_DAYS';

export const SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL = 'SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL';
export const SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL = 'SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL';
export const SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL = 'SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL';

export const GET_AUDIO_BOOKS_ALLOCATION = 'GET_AUDIO_BOOKS_ALLOCATION';
export const GET_AUDIOBOOKS_DETAILS = 'GET_AUDIOBOOKS_DETAILS';
export const GET_CAMPAIGN_AND_CHANNEL = 'GET_CAMPAIGN_AND_CHANNEL';
export const GET_CAMPAIGN_DETAILS = 'GET_CAMPAIGN_DETAILS';

export const DOWNLOAD_PDF = 'DOWNLOAD_PDF';
export const DOWNLOAD_PDF_LOADING = 'DOWNLOAD_PDF_LOADING';
export const DOWNLOAD_PDF_ERROR = 'DOWNLOAD_PDF_ERROR';

export const DOWNLOAD_OVERALL_REPORT_LOADING = 'DOWNLOAD_OVERALL_REPORT_LOADING';
export const DOWNLOAD_OVERALL_REPORT = 'DOWNLOAD_OVERALL_REPORT';
export const DOWNLOAD_OVERALL_REPORT_ERROR = 'DOWNLOAD_OVERALL_REPORT_ERROR';

export const SAVE_KPI_DATA_DUMP = 'SAVE_KPI_DATA_DUMP';
export const DOWNLOAD_KPI_DATA_DUMP = 'DOWNLOAD_KPI_DATA_DUMP';

export const FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS = 'FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS';
export const FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING = 'FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING';
export const FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR = 'FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR';
export const FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS = 'FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS';
export const FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS = 'FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS';

export const FETCH_TOTAL_MEALS_ADDED_SUCCESS = 'FETCH_TOTAL_MEALS_ADDED_SUCCESS';
export const FETCH_TOTAL_MEALS_ADDED_LOADING = 'FETCH_TOTAL_MEALS_ADDED_LOADING';
export const FETCH_TOTAL_MEALS_ADDED_ERROR = 'FETCH_TOTAL_MEALS_ADDED_ERROR';
export const FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS = 'FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS';
export const FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS = 'FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS';

export const FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS = 'FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS';
export const FETCH_TOTAL_AI_COACH_MESSAGES_LOADING = 'FETCH_TOTAL_AI_COACH_MESSAGES_LOADING';
export const FETCH_TOTAL_AI_COACH_MESSAGES_ERROR = 'FETCH_TOTAL_AI_COACH_MESSAGES_ERROR';
export const FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS = 'FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS';
export const FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS = 'FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS';

export const FETCH_UNIQUE_NUTRITION_USERS_SUCCESS = 'FETCH_UNIQUE_NUTRITION_USERS_SUCCESS';
export const FETCH_UNIQUE_NUTRITION_USERS_LOADING = 'FETCH_UNIQUE_NUTRITION_USERS_LOADING';
export const FETCH_UNIQUE_NUTRITION_USERS_ERROR = 'FETCH_UNIQUE_NUTRITION_USERS_ERROR';
export const FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS = 'FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS';
export const FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS = 'FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS';